export default __webpack_public_path__ + "static/media/tennis-green.51db8631.png";